/*@ngInject*/
const SubmissionStateModel = function ($rootScope, $window, appTypeConfigurationModel) {
    var viewModel = {},
        sessionStorageKey = 'submission.state';

    function loadFromStorage() {
        viewModel = JSON.parse($window.sessionStorage.getItem(appTypeConfigurationModel.appendConsoleType(sessionStorageKey))) || {};
    }

    function saveInStorage() {
        $window.sessionStorage.setItem(appTypeConfigurationModel.appendConsoleType(sessionStorageKey), JSON.stringify(viewModel));
    }

    function saveSession(submissionId, key, value) {
        if (_.isEmpty(viewModel[submissionId])) {
            viewModel[submissionId] = {};
        }

        viewModel[submissionId][key] = value;

        saveInStorage();
    }

    function getFromSession(submissionId, key, defaultValue) {
        if (_.has(viewModel, submissionId)) {
            return _.get(viewModel, [submissionId, key].join('.'), defaultValue);
        }

        return defaultValue;
    }

    function deleteSession(submissionId, key) {
        delete viewModel[submissionId][key];
        saveInStorage();
    }

    this.saveChecklist = function (submissionId, checklistViewModel) {
        saveSession(submissionId, 'checklist', checklistViewModel);
    };

    this.getChecklist = function (submissionId) {
        return getFromSession(submissionId, 'checklist');
    };

    this.saveCollaboration = function (submissionId, collaborationViewModel) {
        saveSession(submissionId, 'collaboration', collaborationViewModel);
    };

    this.getCollaboration = function (submissionId) {
        return getFromSession(submissionId, 'collaboration');
    };

    this.saveActivityStream = function (submissionId, activityStreamViewModel) {
        saveSession(submissionId, 'activityStream', activityStreamViewModel);
    };

    this.getActivityStream = function (submissionId) {
        return getFromSession(submissionId, 'activityStream');
    };

    this.getStateUrl = function (submissionId) {
        return getFromSession(submissionId, 'stateUrl');
    };

    this.saveStateUrl = function (submissionId, stateName, stateParams) {
        saveSession(submissionId, 'stateUrl', {name: stateName, params: stateParams});
    };

    this.saveDrawerState = function (submissionId, state) {
        saveSession(submissionId, 'drawer', state);
    };

    this.getDrawerState = function (submissionId) {
        return getFromSession(submissionId, 'drawer', true);
    };

    this.saveNewSubmission = function (submission) {
        saveSession('new', 'submission', submission);
    };

    this.deleteNewSubmission = function () {
        deleteSession('new', 'submission');
    };

    this.getNewSubmission = function () {
        return getFromSession('new', 'submission');
    };

    this.saveSnippetsViewerPosition = function (submissionId, params) {
        saveSession(submissionId, 'snippetsViewer', params);
    };

    this.getSnippetsViewerPosition = function (submissionId) {
        return getFromSession(submissionId, 'snippetsViewer');
    };

    this.openChatCollaboration = function (submissionId) {
        var collaborationViewModel = this.getCollaboration(submissionId);

        if (_.isNil(collaborationViewModel)) {
            collaborationViewModel = {
                isOpen: true,
                filterType: 'chat',
                chat: {
                    isVisible: true
                }
            };
        } else {
            collaborationViewModel.isOpen = true;
            collaborationViewModel.filterType = 'chat';
            collaborationViewModel.chat.isVisible = true;
            collaborationViewModel.note.isVisible = false;
            collaborationViewModel.email.isVisible = false;
            collaborationViewModel.attachment.isVisible = false;
            collaborationViewModel.task.isVisible = false;
        }

        return this.saveCollaboration(submissionId, collaborationViewModel);
    };

    loadFromStorage();
};

angular.module('gw-um-submission')
    .service('submissionStateModel', SubmissionStateModel);
